adminApp.directive('geolocation', function() {
    return {
        templateUrl: '/public/directives/geolocation.html',
        scope: {

        },
        controller: ["$scope", "$interval", "$timeout", "$location", "$rootScope", "$filter", function ($scope, $interval, $timeout, $location, $rootScope, $filter) {
            $scope.locateIP = function(ip){
                if(ip && ip !== ""){
                    $scope.loading = true;
                    store.fetch({
                       path: "/ag/geoLocateIp",
                        queryParams:{
                            ip: ip
                        },
                        success: function(data){
                            if(typeof data == "object"){
                                var fields = $.map(data, function(val, key){
                                   return {
                                       name: key,
                                       value: val,
                                       order: key === 'status'? 1 : 2
                                   }
                                });

                                $scope.result = fields;
                                $scope.message = null;
                            }
                            else {
                                $scope.message = data;
                                $scope.result = null;
                            }
                            getDbLastModified();
                            $scope.loading = false;
                        }
                    });
                }
            }

            function getDbLastModified() {
                store.fetch({
                    path: "/ag/geoLocationDbLastModified",
                    success: function (data) {
                        $scope.dbLastModified = data;
                    }
                })
            }
        }]
    }
});